module.exports = "//static.hsappstatic.net/growthhub-ui/static-1.2283/img/growthhub.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./img/growthhub.svg
// module id = 499
// module chunks = 171